import CompanyInfoSection, { BgImageCompanyInfo } from './CompanyInfoSection';

export { BgImageCompanyInfo };
export default CompanyInfoSection;
